import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
// Feature Status Schema
export const FeatureStatusSchema = z.enum([
    'UNKNOWN',
    'ACTIVATED',
    'DEACTIVATED',
]);
// Feature Name Schema
export const FeatureNameSchema = z.enum([
    'literatureReview',
    'chat',
    'tableView',
    'regulatoryWatch',
    'mcp',
]);
// Workspace Feature Schema
export const WorkspaceFeatureSchema = z.object({
    id: z.string(),
    workspaceId: z.string(),
    feature: FeatureNameSchema,
    status: FeatureStatusSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
// Bulk Update Workspace Features Input Schema
export const BulkUpdateWorkspaceFeaturesInputSchema = z.object({
    features: z.array(z.object({
        feature: FeatureNameSchema,
        status: FeatureStatusSchema,
    })),
});
// Contract endpoints
export const workspaceFeatureContract = c.router({
    getWorkspaceFeatures: {
        method: 'GET',
        path: '/admin/workspaces/:workspaceId/features',
        summary: 'Get all features for a workspace (admin)',
        pathParams: z.object({
            workspaceId: z.string(),
        }),
        responses: {
            200: z.array(WorkspaceFeatureSchema),
            401: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
            404: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
        },
    },
    updateWorkspaceFeature: {
        method: 'PATCH',
        path: '/admin/workspaces/:workspaceId/features',
        summary: 'Update workspace feature status (admin)',
        pathParams: z.object({
            workspaceId: z.string(),
        }),
        body: BulkUpdateWorkspaceFeaturesInputSchema,
        responses: {
            200: z.array(WorkspaceFeatureSchema),
            401: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
            404: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
        },
    },
});
//# sourceMappingURL=workspaceFeature.js.map